var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import config from "../../config";
import { getUrlParameter } from "../../utils";
import { getProductStatus } from "../utils";
import { ProductStatus } from "../../@types/enums/ProductStatus";
import Box from "../../box/Box";
import InStockView from "./instock/InStockView";
import OOSView from "../shared/OOSView";
import DiscontinuedView from "../shared/DiscontinuedView";
import { FavoriteContainerButton } from "../shared/favorites";
import ProductSelect from "../shared/ProductSelect";
import PromoDiscount, { getActivePromoDiscountConfig } from "../shared/PromoDiscount";
function DefaultBuyBox(_a) {
    var _b;
    var products = _a.products, promoDiscountConfigs = _a.promoDiscountConfigs, _c = _a.productSelectLabel, productSelectLabel = _c === void 0 ? "Product" : _c, _d = _a.freeShippingThreshold, freeShippingThreshold = _d === void 0 ? config.FREE_SHIPPING_THRESHOLD_DEFAULT : _d, onProductChange = _a.onProductChange, productNameTransform = _a.productNameTransform, _e = _a.showFavoritesButton, showFavoritesButton = _e === void 0 ? true : _e, _f = _a.showFooter, showFooter = _f === void 0 ? true : _f, onSuccess = _a.onSuccess, onError = _a.onError, buyBoxRef = _a.buyBoxRef, addToBagMiddleware = _a.addToBagMiddleware, rest = __rest(_a, ["products", "promoDiscountConfigs", "productSelectLabel", "freeShippingThreshold", "onProductChange", "productNameTransform", "showFavoritesButton", "showFooter", "onSuccess", "onError", "buyBoxRef", "addToBagMiddleware"]);
    var _g = useState(function () {
        products.sort(function (a, b) {
            return a.in_stock === b.in_stock ? 0 : a.in_stock ? -1 : 1;
        });
        var pid = getUrlParameter("pid");
        if (pid) {
            var match = products.find(function (prod) { return prod.id === Number(pid); });
            if (match) {
                return match;
            }
        }
        var inStockProducts = products.filter(function (product) {
            return getProductStatus(product) === ProductStatus.InStock;
        });
        if (inStockProducts.length > 0) {
            return inStockProducts[0];
        }
        return products[0];
    }), selectedProduct = _g[0], setProduct = _g[1];
    useEffect(function () {
        onProductChange && onProductChange(selectedProduct);
    }, [selectedProduct, onProductChange]);
    if (!products || products.length === 0) {
        console.error("Default BuyBox: no products provided");
        return null;
    }
    if (!selectedProduct) {
        return null;
    }
    var activePromoConfig = promoDiscountConfigs
        ? getActivePromoDiscountConfig(selectedProduct.id, promoDiscountConfigs)
        : null;
    return (React.createElement(Box, __assign({ ref: buyBoxRef }, rest),
        activePromoConfig && React.createElement(PromoDiscount, { promoDiscountConfig: activePromoConfig, mb: 4 }),
        React.createElement(ProductSelect, { label: productSelectLabel, selectedProduct: selectedProduct, products: products, productNameTransform: productNameTransform, onProductChange: setProduct }),
        (_b = {},
            _b[ProductStatus["InStock"]] = (React.createElement(InStockView, { promoDiscountConfig: activePromoConfig, onSuccess: onSuccess, onError: onError, addToBagMiddleware: addToBagMiddleware, product: selectedProduct, freeShippingThreshold: freeShippingThreshold, showFooter: showFooter }, showFavoritesButton && (React.createElement(FavoriteContainerButton, { mt: 2, productId: selectedProduct.id })))),
            _b[ProductStatus["OutOfStock"]] = (React.createElement(OOSView, { product: selectedProduct }, showFavoritesButton && (React.createElement(FavoriteContainerButton, { mt: 2, productId: selectedProduct.id })))),
            _b[ProductStatus["Discontinued"]] = React.createElement(DiscontinuedView, null),
            _b)[getProductStatus(selectedProduct)]));
}
export default DefaultBuyBox;
//# sourceMappingURL=DefaultBuyBox.js.map